import { render, staticRenderFns } from "./ButtonCopyQrImage.vue?vue&type=template&id=6d0b6175&lang=pug"
import script from "./ButtonCopyQrImage.vue?vue&type=script&lang=ts"
export * from "./ButtonCopyQrImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports